// addDAFormConfig.js

import {
  cilCalendar,
  cilDescription,
  cilEnvelopeClosed,
  cilFlagAlt,
  cilGraph,
  cilInfo,
  cilItalic,
  cilLink,
  cilScreenSmartphone,
  cilStar,
  cilUser,
} from '@coreui/icons';
import { CFormCheck } from '@coreui/react';
import dayjs from 'dayjs';
import moment from 'moment';
import GoogleAddressInput from 'src/components/googleAddress/GoogleAddressInput';
import CustomInput from 'src/components/InputsComponent/CustomInput';
import CustomSelectInput from 'src/components/InputsComponent/CustomSelectInput';
import RadioGroupBtn from 'src/components/InputsComponent/RadioGroupBtn';
import CustomDatePicker from 'src/components/UI/DatePicker';
import ImagePicker from 'src/components/UI/ImagePicker';
import globalutil from 'src/util/globalutil';

export const OFFERING_TYPE = [
  { id: 1, name: 'Full Time' },
  { id: 2, name: 'Part Time' },
  { id: 3, name: 'Seasonal' },
];

export const SUFFIX = [
  { id: 1, name: 'Mr.' },
  { id: 2, name: 'Mrs.' },
  { id: 3, name: 'Ms.' },
  { id: 4, name: 'He' },
  { id: 5, name: 'Him' },
  { id: 6, name: 'She' },
  { id: 7, name: 'Her' },
  { id: 8, name: 'They' },
  { id: 9, name: 'Them' },
  { id: 10, name: 'Jr.' },
  { id: 11, name: 'Sr.' },
  { id: 12, name: 'I' },
  { id: 13, name: 'II' },
  { id: 14, name: 'III' },
  { id: 15, name: 'IV' },
  { id: 16, name: 'V' },
];

// ─────────────────────────────────────────────
// TAB 1 — Basic Info
// ─────────────────────────────────────────────
export const getDaApplyBasicInputs = (
  daUserData,
  handleUserInput,
  handleEmailChange,
  emailReadonly,
  emailMessage,
  onBlur,
  dspsListRes,
  dsp,
  onUniformSizeModalOpen,
) => [
  {
    component: ImagePicker,
    image: daUserData.avatar,
    name: 'avatar',
    onChange: (e) => handleUserInput(e, 'avatar'),
  },
  {
    component: CustomInput,
    label: 'First Name',
    value: daUserData.firstName,
    onChange: handleUserInput,
    icon: cilUser,
    type: 'text',
    id: 'FirstName',
    name: 'firstName',
    placeholder: 'First Name',
    className: 'form-control item',
    isRequired: true,
    maxLength: 20,
    autoFocus: true,
    message: 'Enter First Name',
  },
  {
    component: CustomInput,
    label: 'Middle Name',
    value: daUserData.middleName,
    onChange: handleUserInput,
    icon: cilUser,
    type: 'text',
    id: 'middleName',
    name: 'middleName',
    placeholder: 'Middle Name',
    className: 'form-control item',
    isRequired: false,
    maxLength: 20,
    message: 'Enter Middle Name',
  },
  {
    component: CustomInput,
    label: 'Last Name',
    value: daUserData.lastName,
    onChange: handleUserInput,
    icon: cilUser,
    type: 'text',
    id: 'lastName',
    name: 'lastName',
    placeholder: 'Last Name',
    className: 'form-control item',
    isRequired: true,
    maxLength: 20,
    message: 'Enter Last Name',
  },
  {
    component: CustomInput,
    label: 'Email Address',
    labelNote: 'Brand new email is required',
    value: daUserData.email,
    onChange: handleEmailChange,
    icon: cilEnvelopeClosed,
    type: 'email',
    id: 'email',
    name: 'email',
    placeholder: 'Email Address',
    className: 'form-control item',
    isRequired: true,
    onBlur: onBlur,
    message: emailMessage,
  },
  {
    component: CustomInput,
    label: 'Contact',
    value: daUserData.primaryContact,
    onChange: handleUserInput,
    icon: cilScreenSmartphone,
    type: 'text',
    id: 'primaryContact',
    name: 'primaryContact',
    placeholder: 'Enter Contact',
    className: 'form-control item',
    isRequired: true,
    maxLength: 10,
    pattern: '\\d{10}',
    message: 'Enter valid contact number Format: 1234567890',
  },
  {
    component: CFormCheck,
    name: 'isWhatsAppAsso',
    checked: daUserData.isWhatsAppAsso,
    onChange: handleUserInput,
    className: 'mt-5 mblView',
    id: 'isWhatsAppAsso',
    label: 'Is this whatsapp associated?',
  },
  {
    component: CustomSelectInput,
    label: 'Suffix',
    icon: cilFlagAlt,
    id: 'suffix',
    className: 'form-control item form-select',
    value: daUserData.suffix,
    options: globalutil?.suffixes(),
    name: 'suffix',
    placeholder: 'Enter Suffix',
    type: 'text',
    onChange: (e) => handleUserInput(e),
    isRequired: true,
    title: 'Suffix',
    message: 'Please select suffix',
  },
  {
    component: CustomSelectInput,
    label: 'Offering Type',
    icon: cilInfo,
    id: 'offerType',
    options: OFFERING_TYPE,
    className: 'form-control item form-select',
    value: daUserData.offerType,
    name: 'offerType',
    onChange: (e) => handleUserInput(e),
    isRequired: true,
    disableOption: 'Select Offering Type',
    message: 'Please Select Offering Type',
  },
  {
    component: CustomSelectInput,
    label: 'Position(s)',
    icon: cilGraph,
    id: 'positionType',
    options: globalutil?.userroles()?.filter((role) => role?.id === 3 || role?.id === 8) ?? [],
    className: 'form-control item form-select',
    value: daUserData.positionType,
    name: 'positionType',
    onChange: (e) => {
      const selectedValue = Number(e.target.value);
      const userAge = moment().diff(moment(daUserData.dob), 'years');
      if (selectedValue === 3 && userAge < 21) {
        handleUserInput(moment().subtract(21, 'years').format('YYYY-MM-DD'), 'dob');
      }
      if (selectedValue === 8 && userAge < 18) {
        handleUserInput(moment().subtract(18, 'years').format('YYYY-MM-DD'), 'dob');
      }
      handleUserInput(e);
    },
    isRequired: true,
    disableOption: 'Select Position Type',
    message: 'Please Select Position Type',
    showDisabled: true,
  },
  {
    component: CustomSelectInput,
    label: 'Uniform Size',
    icon: cilInfo,
    id: 'uniformSize',
    options: globalutil.uniformsizes().sort((a, b) => a.sortOrder - b.sortOrder),
    optionsList: (option) =>
      `${option.code} · ${option.sortOrder === 1 ? 'Men' : 'Women'} · ${
        option.sortOrder === 1 ? 'Chest' : 'Bust'
      } ${option.name} · Waist ${option.desc}`,
    className: 'form-control item form-select',
    value: daUserData.uniformSize,
    name: 'uniformSize',
    onChange: (e) => handleUserInput(e),
    isRequired: false,
    disableOption: 'Select Uniform Size',
    message: 'Please select uniform size',
    showDisabled: false,
    disabled: false,
    actionIcon: cilStar,
    onActionIconClick: onUniformSizeModalOpen,
  },
  {
    component: CustomSelectInput,
    label: 'DSP',
    icon: cilInfo,
    id: 'dspid',
    options: dspsListRes,
    className: 'form-control item form-select',
    value: daUserData.dspid,
    name: 'dspid',
    onChange: (e) => handleUserInput(e),
    isRequired: true,
    disableOption: 'Select DSP',
    message: 'Please select DSP',
    disabled: !!dsp,
  },
  {
    component: CustomDatePicker,
    icon: cilCalendar,
    label: 'Date of Birth',
    value: daUserData.dob,
    onChange: (e) => handleUserInput(e, 'dob'),
    isRequired: true,
    noDefault: true,
    max: dayjs().subtract(daUserData.positionType == 3 ? 21 : 18, 'years'),
    title: 'Enter date of birth',
    message: 'DA age should be 21 or above',
  },
  {
    component: GoogleAddressInput,
    label: 'Mailing Address',
    value: daUserData.mailAddress,
    onChange: handleUserInput,
    icon: cilUser,
    skipCurrentAddress: true,
    isRequired: true,
    type: 'text',
    id: 'mailAddress',
    name: 'mailAddress',
    placeholder: 'Enter Mailing Address',
    className: 'form-control item',
  },
  {
    component: CustomInput,
    label: 'Signature',
    value: daUserData.signature,
    onChange: handleUserInput,
    icon: cilDescription,
    type: 'text',
    id: 'signature',
    name: 'signature',
    placeholder: 'Enter full legal name as signature',
    className: 'form-control item',
    isRequired: true,
    maxLength: 60,
    message: 'Please enter your signature (full legal name)',
  },
];

// ─────────────────────────────────────────────
// TAB 2 — License & DOT
// ─────────────────────────────────────────────
export const getDaApplyLicenseInputs = (
  daUserData,
  handleUserInput,
  daIdentificationData,
  handleDAIdentification,
) => [
  {
    component: CustomInput,
    label: 'License #',
    value: daUserData.licenseNo,
    onChange: handleUserInput,
    icon: cilDescription,
    type: 'text',
    id: 'licenseNo',
    name: 'licenseNo',
    placeholder: 'Enter license number',
    className: 'form-control item',
    isRequired: true,
    maxLength: 20,
    minLength: 5,
    message: 'Enter valid license number',
    title: 'Enter license number',
  },
  {
    component: CFormCheck,
    name: 'hasValidDrivingLicense',
    checked: daUserData.hasValidDrivingLicense,
    onChange: handleUserInput,
    className: 'mt-5 mblView',
    id: 'hasValidDrivingLicense',
    label: 'Has Valid License?',
  },
  {
    component: CustomSelectInput,
    label: 'Lic. Issuing State',
    icon: cilFlagAlt,
    id: 'issuingStateId',
    options: globalutil.states(),
    className: 'form-control item form-select',
    value: daUserData.issuingStateId,
    name: 'issuingStateId',
    onChange: (e) => handleUserInput(e),
    isRequired: true,
    disableOption: 'Select License Issuing State',
    title: 'Select License Issuing State',
    message: 'Please select your state',
  },
  {
    component: CustomDatePicker,
    icon: cilCalendar,
    label: 'License Issue Date',
    value: daUserData.licenseIssueDate,
    onChange: (e) => handleUserInput(e, 'licenseIssueDate'),
    isRequired: true,
    max: dayjs().subtract(1, 'day'),
    message: 'Enter Valid Issue Date',
    noDefault: true,
  },
  {
    component: CustomDatePicker,
    icon: cilCalendar,
    label: 'License Exp. Date',
    value: daUserData.licenseExpiryDate,
    onChange: (e) => handleUserInput(e, 'licenseExpiryDate'),
    isRequired: true,
    min: dayjs().add(1, 'day'),
    title: 'Enter licence expiry date',
    message: 'Enter Valid Exp Date',
    noDefault: true,
  },
  {
    component: CustomInput,
    label: 'Attach License (Front)',
    onChange: (e) => handleDAIdentification(e),
    icon: cilLink,
    type: 'file',
    id: 'licenceImageFront',
    name: 'licenceImageFront',
    placeholder: 'License copy upload',
    className: 'form-control item',
    accept: 'image/*,.heic,.HEIC,.heif,application/pdf',
    isRequired: true,
    title: 'Attach license front side picture',
    message: 'Please attach license front side',
    helperText: daIdentificationData.licenceImageFront?.name ?? '',
    src: daIdentificationData.licenceImageFront?.src ?? '',
  },
  {
    component: CustomInput,
    label: 'Attach License (Back)',
    onChange: (e) => handleDAIdentification(e),
    icon: cilLink,
    type: 'file',
    id: 'licenceImageBack',
    name: 'licenceImageBack',
    placeholder: 'License copy upload',
    className: 'form-control item',
    isRequired: true,
    accept: 'image/*,.heic,.HEIC,.heif,application/pdf',
    title: 'Attach licence back side picture',
    message: 'Please attach license back side',
    helperText: daIdentificationData.licenceImageBack?.name ?? '',
    src: daIdentificationData.licenceImageBack?.src ?? '',
  },
  {
    component: RadioGroupBtn,
    label: 'DOT Certified?',
    value: daUserData.isDOTCertified,
    name: 'isDOTCertified',
    isButton: true,
    onChange: (e) => handleUserInput(e),
    options: [
      { id: 1, name: 'Yes' },
      { id: 2, name: 'No' },
    ],
  },
  ...(daUserData.isDOTCertified == 1
    ? [
        {
          component: CustomDatePicker,
          icon: cilCalendar,
          label: 'DOT Exp. Date',
          value: daUserData.dotExpDate,
          onChange: (e) => handleUserInput(e, 'dotExpDate'),
          isRequired: true,
          min: dayjs().add(1, 'day'),
          title: 'Enter DOT expiry date',
          message: 'Enter Valid DOT Exp Date',
          noDefault: true,
        },
        {
          component: CustomInput,
          label: 'Attach DOT Certificate',
          onChange: (e) => handleDAIdentification(e),
          accept: 'image/*,.heic,.HEIC,.heif,application/pdf',
          icon: cilLink,
          type: 'file',
          id: 'dotCertificate',
          name: 'dotCert',
          placeholder: 'DOT Certificate upload',
          className: 'form-control item',
          isRequired:
            daUserData.isDOTCertified == 1 &&
            (!daIdentificationData.dotCert || daIdentificationData.dotCert === ''),
          message: 'Please attach DOT Certificate',
          helperText: daIdentificationData.dotCert?.name ?? '',
          src:
            daIdentificationData.dotCert === ''
              ? ''
              : daIdentificationData.dotCert?.type !== 'application/pdf'
              ? daIdentificationData.dotCert?.src
              : 'pdf',
        },
      ]
    : []),
];

// ─────────────────────────────────────────────
// TAB 3 — SSN
// ─────────────────────────────────────────────
export const getDaApplySsnInputs = (daIdentificationData, handleDAIdentification) => [
  {
    component: CustomInput,
    label: 'SSN No',
    value: daIdentificationData.ssnNo,
    onChange: (e) => {
      const value = e.target.value.replace(/\D/g, '').slice(0, 9);
      handleDAIdentification({ ...e, target: { ...e.target, value, name: 'ssnNo' } });
    },
    icon: cilItalic,
    type: 'text',
    id: 'ssnNo',
    name: 'ssnNo',
    placeholder: 'SSN No',
    className: 'form-control item',
    isRequired: true,
    maxLength: 9,
    message:
      'Enter a valid SSN No (9 digits, first three digits must be between 001-999, excluding 666)',
    pattern: '^(?!666)(?!000)[0-9]{3}(?!00)[0-9]{2}(?!0000)[0-9]{4}$',
  },
  {
    component: CustomInput,
    label: 'Attach Copy (Front)',
    onChange: (e) => handleDAIdentification(e),
    accept: 'image/*,.heic,.HEIC,.heif,application/pdf',
    icon: cilLink,
    type: 'file',
    id: 'ssnFront',
    name: 'ssnFront',
    placeholder: 'SSN copy front upload',
    className: 'form-control item',
    isRequired: true,
    message: 'Please attach SSN front copy',
    helperText: daIdentificationData.ssnFront?.name ?? '',
    src: daIdentificationData.ssnFront?.src ?? '',
  },
  {
    component: CustomInput,
    label: 'Attach Copy (Back)',
    onChange: (e) => handleDAIdentification(e),
    accept: 'image/*,.heic,.HEIC,.heif,application/pdf',
    icon: cilLink,
    type: 'file',
    id: 'ssnBack',
    name: 'ssnBack',
    placeholder: 'SSN copy back upload',
    className: 'form-control item',
    isRequired: false,
    message: 'SSN copy back upload',
    helperText: daIdentificationData.ssnBack?.name ?? '',
    src: daIdentificationData.ssnBack?.src ?? '',
  },
];

// ─────────────────────────────────────────────
// TAB 4 — Birth Certificate
// ─────────────────────────────────────────────
export const getDaApplyBirthInputs = (daIdentificationData, handleDAIdentification) => [
  {
    component: CustomSelectInput,
    label: 'Country',
    icon: cilFlagAlt,
    id: 'bCertificateCountry',
    options: globalutil.countries(),
    className: 'form-control item form-select',
    value: daIdentificationData.bCertificateCountry,
    name: 'bCertificateCountry',
    onChange: (e) => handleDAIdentification(e),
    isRequired: false,
    message: 'Please select your country',
  },
  {
    component: CustomSelectInput,
    label: 'State / Province',
    icon: cilFlagAlt,
    id: 'bCertificateState',
    options:
      daIdentificationData.bCertificateCountry == 1
        ? globalutil.states().filter((a) => a?.desc == 1)
        : globalutil.states().filter((a) => a?.desc == 2),
    className: 'form-control item form-select',
    disableOption:
      daIdentificationData.bCertificateCountry === '' ? 'Select a country first' : 'Select State',
    value: daIdentificationData.bCertificateState,
    name: 'bCertificateState',
    onChange: (e) => handleDAIdentification(e),
    isRequired: false,
    message: 'Please select your state',
  },
  {
    component: CustomInput,
    label: 'Birth Certificate No',
    value: daIdentificationData.bCertificateNo,
    onChange: handleDAIdentification,
    icon: cilLink,
    type: 'text',
    id: 'bCertificateNo',
    name: 'bCertificateNo',
    placeholder: 'Birth Certificate No',
    className: 'form-control item',
    isRequired: false,
    maxLength: 14,
    message: 'Enter Birth Certificate No',
  },
  {
    component: CustomInput,
    label: 'Attach Copy',
    onChange: handleDAIdentification,
    icon: cilLink,
    type: 'file',
    accept: 'image/*,.heic,.HEIC,.heif',
    id: 'bCertificateFile',
    name: 'bCertificateFile',
    placeholder: 'Birth certificate copy upload',
    className: 'form-control item',
    isRequired: false,
    message: 'Birth certificate copy upload',
    helperText: daIdentificationData.bCertificateFile?.name ?? '',
    src: daIdentificationData.bCertificateFile?.src ?? '',
  },
];

// ─────────────────────────────────────────────
// Initial State
// ─────────────────────────────────────────────
export const getInitialDaData = () => ({
  id: 0,
  avatar: '',
  firstName: '',
  middleName: '',
  lastName: '',
  dspid: '',
  offerType: OFFERING_TYPE[0].id,
  primaryContact: '',
  positionType: 3,
  email: '',
  userId: '',
  badgeId: '',
  licenseNo: '',
  issuingStateId: '',
  licenseIssueDate: null,
  licenseExpiryDate: null,
  dotExpDate: null,
  dob: null,
  isWhatsAppAsso: false,
  hasValidDrivingLicense: false,
  isDOTCertified: '',
  status: 5,
  isTermsAccepted: false,
  suffix: globalutil?.suffixes()?.[0]?.id || '',
  mailAddress: '',
  signature: '',
  createdAt: moment().utc().format(),
  lastUpdatedAt: moment().utc().format(),
  createdBy: 1,
  lastUpdatedBy: 1,
  uniformSize: '',
});

export const getInitialDaIdentificationData = () => ({
  licenceImageFront: '',
  licenceImageBack: '',
  dotCert: '',
  ssnNo: '',
  ssnFront: '',
  ssnBack: '',
  bCertificateCountry: '',
  bCertificateState: '',
  bCertificateNo: '',
  bCertificateFile: '',
});
